var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.5 49.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.84,48.88H7.16v-15.04C3.22,30.36.75,25.34.75,19.76.75,9.25,9.48.75,20.25.75s19.48,8.5,19.48,19.01c0,.72-.04,1.45-.12,2.16-.04.35.02.71.2,1.02l3.91,6.86c.47.81,0,1.84-.91,2.03l-4.02.83v6.5c0,1.12-.91,2.03-2.05,2.03h-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.66,48.88h22.68v-15.04c3.93-3.48,6.41-8.5,6.41-14.08C58.75,9.25,50.02.75,39.25.75s-19.48,8.5-19.48,19.01c0,.72.04,1.45.12,2.16.04.35-.02.71-.2,1.02l-3.91,6.86c-.47.81,0,1.84.91,2.03l4.02.83v6.5c0,1.12.91,2.03,2.05,2.03h8.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.66,
    y1: 41.19,
    x2: 29.66,
    y2: 48.88
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentStyle);
export default __webpack_public_path__ + "static/media/attachment-style.b45f9522143f08b226fbf625678b6362.svg";
export { ForwardRef as ReactComponent };